import { ThemeProvider } from "@mui/material";
import { Analytics } from '@vercel/analytics/react';
import { Theme, useThemes } from "./Theme";
import MyRoutes from "./Routes";
import { useMemo } from "react";

function App() {
  const theme = useThemes();
  const muiTheme = useMemo(() => Theme(theme), [theme]);

  return (
    <ThemeProvider theme={ Theme(theme)}>
      <MyRoutes />
      <Analytics/>
    </ThemeProvider>
  );
}

export default App;
 